import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { TextInput } from '../../component/TextInput';

export function MarketingBannerSection({
  desktopCopy,
  setDesktopCopy,
  mobileCopy,
  setMobileCopy,
}: {
  desktopCopy: string;
  setDesktopCopy: (v: string) => void;
  mobileCopy: string;
  setMobileCopy: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <h2>
        Marketing Site Promotion Banner <span className="text-xs">(Optional)</span>
      </h2>
      <p className="text-xs text-gray-500 font-normal mb-2">
        Customer-facing banner to be displayed on the marketing site
      </p>

      <div className="w-full mb-2">
        <h3 className="flex">Desktop Copy</h3>
        <TextInput placeholder="None" value={desktopCopy} setTextChange={setDesktopCopy} />
      </div>

      <div className="w-full mb-2">
        <h3 className="flex">Mobile Copy</h3>
        <TextInput placeholder="None" value={mobileCopy} setTextChange={setMobileCopy} />
      </div>
    </PromotionSectionCard>
  );
}
